import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SelectMultipleField from '../../../../../FormControl/input/SelectMultipleField'
import { updateClassMarkingLcsIds } from '../../../../../../store/actions/class-marking.actions'

const SelectLearningContinuumMultiple = () => {
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  if (!currentCurriculum) return <></>;
  const lcElement = currentCurriculum?.lcElements?.children?.sort((a, b) => b.position - a.position)[0];

  if (!lcElement) return <></>;

  const lcsIds = useSelector((state) => state?.classMarking.lcsIds || [])
  const options = useSelector((state) => state?.class?.unitOfLearning?.lcs || []);
  const dispatch = useDispatch()

  const onChange = (value) => {
    dispatch(updateClassMarkingLcsIds(value))
  }
  
  return (
    <div className='max-w-150px min-w-100px'>
      <SelectMultipleField
        id="learning-continuum"
        placeholder={lcElement.name}
        value={lcsIds}
        options={options.map((option) => ({ value: option._id, label: option?.lcElements?.[lcElement._id] }))}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}

export default SelectLearningContinuumMultiple